<template>
  <el-collapse v-model="activeCollapses" class="collapse-main-content">
    <el-collapse-item name="1">
      <template slot="title">
        <div class="collapse-title-pre" style="width: 100%; position: relative">
          <span></span>
          合同信息
          <div style="position: absolute; right: 10px; top: -9px" v-if="operateType === 'detail'">
            <el-button type="primary" @click="viewContract">查看关联合同</el-button>
            <el-button type="primary" @click="viewReciveables">查看应收费用</el-button>
          </div>
        </div>
      </template>
      <div class="collapse-content">
        <SiruiSearch
          ref="contractRef"
          :query="contractInfoData"
          :columns="baseColumns"
          :rules="rules"
          :isQueryPanel="false"
          @changeChargeMethodHandler="changeChargeMethodHandler"
          @firstSettlementDateIconHandler="firstSettlementDateIconHandler"
          :isDisabledForm="operateType === 'detail'"
        ></SiruiSearch>
      </div>
    </el-collapse-item>
    <FirstSettlementDialog ref="firstSettlementDialogRef" />
  </el-collapse>
</template>

<script>
  import {
    baseFixedFormRules,
    baseNotFixedFormRules,
    baseDataInfoFixedColumn,
    baseDataInfoNotFixedColumn,
  } from '../data';
  import { mapState } from 'vuex';
  import API from '@/api/property/leaseContract';
  import leaseContractMixin from '@/pages/property/leaseContract/mixins/leaseContract';
  // import moment from 'moment';
  import COMPANY_API from '@/api/masterData/company.js';
  import moment from 'moment';
  import FirstSettlementDialog from './FirstSettlementDialog';
  export default {
    name: 'contractInfo',
    mixins: [leaseContractMixin],
    props: ['contractCategory'],
    data() {
      return {
        activeCollapses: ['1'],
        contractInfoData: {
          contractCompanyName: '',
          contractCompanyNo: '',
          contractDepartmentNo: '',
          contractDepartmentName: '',
          contractNo: '',
          contractName: '',
          customerCode: '',
          customerName: '',
          creditCode: '',
          contractCategory: '',
          leaseDateFrom: '',
          leaseDateUntil: '',
          chargeMethod: '',
          totalRentAmount: '',
          rentAmount: '',
          chargeCycle: '',
          firstSettlementDate: '',
          rentAnnualGrowthRate: '',
          collectionOverdueDay: '',
          defaultPenaltyRate: '',
          signPartyName: '',
          signDate: '',
          signPersonName: '',
          signPlace: '',
          paperContractNo: '',
          relateContractId: '',
          partyaBankAccount: '',
          partyaDepositBank: '',
          partyaContactPerson: '',
          partyaContactPhone: '',
          partybInvoiceInfo: '',
          partybContactPerson: '',
          partybContactPhone: '',
          remark: '',
          invoiceType: '',
        },
        departmentList: [], // 部门下拉
        relatedContractList: [], // 关联合同
        operateType: '',
        isFixedPriceFlag: false, // 计费方式是否固定价
        showSignPartyNameFlag: false,
        dateFrom: '',
        dateUntil: '',
        baseFixedFormRules,
        baseNotFixedFormRules,
        rules: {},
        isShowTotalRentAmount: false,
        isHidden: '', //判断是否为物业合同
      };
    },
    mounted() {
      this.operateType = this.$route.query.type;
      this.contractInfoData.contractCategory = '01';
      this.initListData();
      this.changeRules();

      console.log(this.userInfo, 'userInfo');
      if (['detail', 'audit'].includes(this.operateType)) {
        this.isShowTotalRentAmount = true;
      }
      if (this.operateType === 'add') {
        // 新增时所属公司为用户当前公司 其他情况为详情返回的公司名称
        this.contractInfoData.contractCompanyName = this.userInfo.companyName;
        this.contractInfoData.contractCompanyNo = this.userInfo.companyCode;
        this.contractInfoData.contractDepartmentNo = this.userInfo.departmentCode;
        this.contractInfoData.contractDepartmentName = this.userInfo.departmentName;
        if (this.userInfo.companyName === '广西供应链服务集团桂林储运有限公司') {
          this.showSignPartyNameFlag = true;
          this.contractInfoData.signPartyName = '桂林储运';
        } else {
          this.showSignPartyNameFlag = false;
          this.contractInfoData.signPartyName = '';
        }
      }
      if (this.operateType === 'add' && this.nicheId) {
        // 招商合同新增
        this.contractInfoData.contractCompanyName = this.userInfo.companyName;
        this.contractInfoData.contractCompanyNo = this.userInfo.companyCode;
        this.contractInfoData.contractDepartmentNo = this.userInfo.departmentCode;
        this.contractInfoData.contractDepartmentName = this.userInfo.departmentName;
        this.contractInfoData.customerCode = this.$route.query.customerCode;
        this.contractInfoData.customerName = this.$route.query.customerName;
        // this.contractInfoData.creditCode = this.$route.query.creditCode;
        this.getCreditInfo();
        if (this.userInfo.companyName === '广西供应链服务集团桂林储运有限公司') {
          this.showSignPartyNameFlag = true;
          this.contractInfoData.signPartyName = '桂林储运';
        } else {
          this.showSignPartyNameFlag = false;
          this.contractInfoData.signPartyName = '';
        }
      }
      this.$nextTick(() => {
        console.log('清空校验');
        this.$refs.contractRef.$refs.queryFrom.clearValidate();
      });
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      isAudit() {
        return this.operateType === 'audit';
      },
      baseColumns() {
        return this.isFixedPriceFlag
          ? baseDataInfoFixedColumn(this)
          : baseDataInfoNotFixedColumn(this);
      },
      isRenewalFlag() {
        return this.operateType === 'renewal';
      },
      isChangeInfoFlag() {
        return this.operateType === 'changeInfo';
      },
      nicheId() {
        return this.$route.query.nicheId;
      },
      pickerSettleOptions() {
        return {
          disabledDate: (time) => {
            return time < new Date(this.dateFrom) - 8.64e7 || time > new Date(this.dateUntil);
          },
        };
      },
    },
    methods: {
      // 查看应收费用
      viewReciveables() {
        let contractNo = this.contractInfoData.contractNo;
        this.$router.push({
          path: '/receivablesAndPayables/receivables',
          query: { contractNo, status: 'leaseContract' },
        });
      },
      firstSettlementDateIconHandler() {
        this.$refs.firstSettlementDialogRef.openModal();
      },
      changeRules() {
        let result = {};
        console.log(this.isFixedPriceFlag, 'this.isFixedPriceFlag');
        if (this.isFixedPriceFlag) {
          result = { ...this.baseFixedFormRules };
        } else {
          result = { ...this.baseNotFixedFormRules };
        }
        this.rules = result;
      },
      getCreditInfo() {
        const params = {
          companyCode: this.userInfo.companyCode,
          departmentCode: this.userInfo.departmentCode,
          pageNum: 1,
          pageSize: 10,
          partnerCode: this.$route.query.customerCode,
          partnerTypes: 'HZHB01, HZHB03',
        };
        this.$axios.post(API.LIST_PARTNEREXTEND, params).then((res) => {
          console.log(res, '1111');
          if (res.data.code === 0) {
            let result = res.data.data.list || [];
            if (result.length > 0) {
              this.contractInfoData.creditCode = result[0].creditCode || result[0].identityNo;
            }
          }
        });
      },
      initListData() {
        this.getDepartmentList();
        this.getContractList();
      },
      // 获取合同信息中部门列表
      getDepartmentList() {
        const params = {
          belongCompanyCode: this.operateType === 'add' ? this.userInfo.companyCode : '',
          tenantCode: this.userInfo.tenantCode,
        };
        this.$axios.post(COMPANY_API.GET_DEPARTMENT_LIST_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data || [];
            if (this.departmentList.length > 0) {
              this.departmentList.map((item) => {
                item.label = item.createDepartmentName;
                item.value = item.createDepartmentCode;
              });
            }
          }
        });
      },
      getContractList() {
        this.$axios.post(API.LEASE_CONTRACT_LIST_PAGE, {}).then((res) => {
          if (res.data.code === 0) {
            this.relatedContractList = res.data.data.records || [];
            if (this.relatedContractList.length > 0) {
              this.relatedContractList.map((item) => {
                (item.label = item.contractName), (item.value = item.id);
              });
            }
          }
        });
      },
      changeChargeMethodHandler(row) {
        console.log(row, '111');
        if (row.prop === 'contractCategory') {
          if (row.val == '02') {
            this.isHidden = true;
            this.contractInfoData.chargeMethod = '';
          } else {
            this.isHidden = false;
          }
          this.$emit('getContractCategory', row.val);
        }
        if (row.prop === 'chargeMethod') {
          this.contractInfoData.totalRentAmount = '';
          if (row.val === '02') {
            this.isFixedPriceFlag = true;
            // 清楚合同总租金
            this.contractInfoData.rentAmount = '';
          } else {
            this.isFixedPriceFlag = false;
            // 清除空间信息中的租金 清楚免租期信息
            this.$emit('clearRentAmount');
          }
          this.$nextTick(() => {
            this.changeRules();
            this.$refs.contractRef.$refs.queryFrom.clearValidate();
          });

          this.$emit('getChargeMethodsValue', row.val);
        }
        if (row.prop === 'leaseDateFrom') {
          this.dateFrom = row.val;
          if (this.isFixedPriceFlag) {
            // 计算合同总金额
            this.calcTotalAmount();
          }
          this.$emit('getLeaseDateFrom', row.val, this.isFixedPriceFlag);
        }
        if (row.prop === 'leaseDateUntil') {
          this.dateUntil = row.val;
          console.log(this.isFixedPriceFlag, 'this.isFixedPriceFlag');
          if (this.isFixedPriceFlag) {
            // 计算合同总金额
            this.calcTotalAmount();
          }
          this.$emit('getLeaseDateUntil', row.val, this.isFixedPriceFlag);
        }
        if (row.prop === 'customerName') {
          console.log(row.val, 'row.val');
          this.contractInfoData.customerName = row.val[0].partnerZhName;
          this.contractInfoData.customerCode = row.val[0].partnerCode;
          this.contractInfoData.creditCode = row.val[0].creditCode || row.val[0].identityNo;
        }
        if (row.prop === 'contractDepartmentNo') {
          const result = this.departmentList.find((item) => {
            return item.createDepartmentCode === row.val;
          });
          this.contractInfoData.contractDepartmentName = result.createDepartmentName;
        }
        // if (row.prop === 'chargeCycle') {
        //   if (this.isFixedPriceFlag) {
        //     // 计算合同总金额
        //     this.calcTotalAmount();
        //   }
        // }
        if (row.prop === 'rentAmount') {
          if (this.isFixedPriceFlag) {
            // 计算合同总金额
            this.calcTotalAmount();
          }
          if (!row.val) {
            this.contractInfoData.totalRentAmount = '';
          }
        }
        if (row.prop == 'rentAnnualGrowthRate') {
          console.log(row.val);
          this.contractInfoData.rentAnnualGrowthRate = row.val + '';
          this.calcTotalAmount();
        }
      },
      /**
       * 根据年，月金额，增长值来计算金额
       * @param {*} year 第几年
       * @param {*} amount 月金额
       * @param {*} rate 年增长
       * @param {*} month 当年几个月
       */
      computedYearRate(year, amount, rate, month = 12) {
        let yearTotal = 0;
        if (year === 1) {
          return [amount, amount * month];
        }

        const foo1 = () => {
          amount = (amount * (1 + rate)).toFixed(2);
          yearTotal = (amount * month).toFixed(2);
        };
        new Array(year - 1).fill(0).forEach(() => foo1());
        return [amount, yearTotal];
      },
      calcTotalAmount() {
        const { rentAmount, chargeCycle, leaseDateUntil, leaseDateFrom, rentAnnualGrowthRate } =
          this.contractInfoData;
        console.log(
          rentAmount,
          chargeCycle,
          leaseDateUntil,
          leaseDateFrom,
          'chargeCycle',
          rentAnnualGrowthRate,
          'TODO等待计算金额'
        );
        if (!rentAmount) {
          return this.$message({
            showClose: true,
            message: '请填写计费单价',
            type: 'warning',
          });
        }
        // if (!chargeCycle) {
        //   return this.$message({
        //     showClose: true,
        //     message: '请选择计费周期',
        //     type: 'warning',
        //   });
        // }
        if (!leaseDateFrom) {
          return this.$message({
            showClose: true,
            message: '请选择租赁期限起始日期',
            type: 'warning',
          });
        }
        if (!leaseDateUntil) {
          return this.$message({
            showClose: true,
            message: '请选择租赁期限截止日期',
            type: 'warning',
          });
        }
        let totalRentAmount = 0;
        const mons = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function lastDay(mo, year) {
          if (mo === 4 || mo === 6 || mo === 9 || mo === 11) {
            return 30;
          }
          //2月
          else if (mo === 2) {
            if (isLeapYear(year)) {
              return 29;
            } else {
              return 28;
            }
          }
          //大月
          else {
            return 31;
          }
        }
        function isLeapYear(Year) {
          return (Year % 4 === 0 && Year % 100 !== 0) || Year % 400 === 0;
        }
        function diff(startDate, endDate) {
          endDate = moment(endDate).add(1, 'days').format('YYYY-MM-DD');
          const date = new Date(startDate);
          const year = date.getFullYear(); // 取当年的年
          const month = date.getMonth() + 1; // 取当年的月(月份加一)
          const dd = date.getDate(); // 取当年的日期
          const nowDate = new Date(endDate); // 取现在的时间
          const nowYear = nowDate.getFullYear(); // 取现在的年
          const nowMonth = nowDate.getMonth() + 1; // 取现在的月(月份加一)
          const nowDd = nowDate.getDate(); // 取现在的日期
          console.log(year, month, dd, nowYear, nowMonth, nowDd, 'nowDd');
          const restDd = nowDd - dd < 0 ? lastDay(nowMonth - 1, year) - dd + nowDd : nowDd - dd;
          const restMonth = nowMonth - month < 0 ? 12 + nowMonth - month : nowMonth - month;
          const restYear = nowYear - year;
          let resultMonth = restMonth;
          let resultYear = restYear;
          if (nowDd < dd) {
            resultMonth = restMonth - 1 < 0 ? restMonth - 1 + 12 : restMonth - 1;
          }
          if (nowMonth < month || (nowDd < dd && nowMonth === month)) {
            resultYear = restYear - 1;
          }
          return [resultYear, resultMonth, restDd];
        }
        console.log(
          diff(leaseDateFrom, leaseDateUntil),
          '计算两个时间年月天',
          mons[new Date(leaseDateUntil).getMonth()]
        );
        let arr = diff(leaseDateFrom, leaseDateUntil); // 返回的是多少年、多少月、多少日
        let everyDayCost = (rentAmount / mons[new Date(leaseDateUntil).getMonth()]).toFixed(2);
        // 根据年月天来计算金额
        const [yearCount, monthCount, dayCount] = arr;
        console.log(
          yearCount,
          monthCount,
          dayCount,
          '时间差多少年月日',
          everyDayCost,
          totalRentAmount
        );
        // TODO 后端计算
        // if (rentAnnualGrowthRate && yearCount >= 1) {
        //   console.log(yearCount, monthCount, dayCount, '时间差多少年月日');
        //   let allYearTotal = 0; // 年总金额

        //   // year, amount, rate, month = 12
        //   for (let i = 1; i <= yearCount; i++) {
        //     const [amount, yearTotal] = this.computedYearRate(
        //       i,
        //       +rentAmount,
        //       +rentAnnualGrowthRate / 100
        //     );
        //     console.log(amount);
        //     allYearTotal += +yearTotal;
        //   }
        //   const [lastMonth, lastMonthTotal] = this.computedYearRate(
        //     yearCount + 1,
        //     +rentAmount,
        //     +rentAnnualGrowthRate / 100,
        //     monthCount
        //   );
        //   const lastOneDayAmount = +lastMonth / mons[new Date(leaseDateUntil).getMonth()];
        //   const lastDayTotal = +lastOneDayAmount.toFixed(2) * dayCount;
        //   console.log(
        //     '年总金额:',
        //     allYearTotal,
        //     '最后月总金额:',
        //     lastMonthTotal,
        //     '最后一天总金额:',
        //     lastDayTotal,
        //     '最后一个月:',
        //     lastMonth
        //   );
        //   const allTotal = +allYearTotal + +lastMonthTotal + +lastDayTotal;
        //   this.contractInfoData.totalRentAmount = allTotal + ''; // 年增长总金额
        // } else {
        //   totalRentAmount = arr[0] * 12 * rentAmount + arr[1] * rentAmount + arr[2] * everyDayCost;
        //   console.log(totalRentAmount, 'totalRentAmount');
        //   this.contractInfoData.totalRentAmount = totalRentAmount.toFixed(6) + '';
        // }
      },
      viewContract() {
        this.$emit('relatedContract');
      },
      getAllAmout(amount) {
        this.contractInfoData.totalRentAmount =
          Number(this.contractInfoData.totalRentAmount) - Number(amount);
      },
    },
    watch: {
      contractCategory(val) {
        console.log('监听');
        if (val == '02') {
          this.isHidden = true;
        } else {
          this.isHidden = false;
        }
        console.log('hhhhh', val, this.isHidden);
      },
    },
    components: {
      FirstSettlementDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
  .contract-box {
    display: flex;
    justify-content: space-between;
  }
</style>
